module.exports = __webpack_public_path__ + "img/code.8550c4c6.png";